import { gql } from '@apollo/client/core'

const ESTIMATE_TAX = gql`
  query estimateTax(
    $product: BillingProduct!
    $providerPromotionCodeId: String
    $zipCode: String
    $country: AddressCountry
  ) {
    estimateTax(
      product: $product
      providerPromotionCodeId: $providerPromotionCodeId
      zipCode: $zipCode
      country: $country
    ) {
      estimatedTax
    }
  }
`

export default ESTIMATE_TAX
